// extracted by mini-css-extract-plugin
export var afterEvent = "countdownBanner-module--after-event--f9cc7";
export var backgroundImage = "countdownBanner-module--background-image--bbbb2";
export var backgroundImageWrapper = "countdownBanner-module--background-image-wrapper--a82a9";
export var backgroundWrapper = "countdownBanner-module--background-wrapper--1b831";
export var beforeEvent = "countdownBanner-module--before-event--96bbc";
export var content = "countdownBanner-module--content--51ae2";
export var countdownBanner = "countdownBanner-module--countdown-banner--86c4e";
export var countdownWrapper = "countdownBanner-module--countdown-wrapper--1f4f4";
export var ctaIcon = "countdownBanner-module--cta-icon--02f3e";
export var ctaLink = "countdownBanner-module--cta-link--f54af";
export var description = "countdownBanner-module--description--291eb";
export var headlineAfterEvent = "countdownBanner-module--headline-after-event--7b7ac";
export var textAfterEvent = "countdownBanner-module--text-after-event--f4e39";
export var textAfterEventSeparator = "countdownBanner-module--text-after-event-separator--63958";
export var textBeforeEvent = "countdownBanner-module--text-before-event--fc44c";